import request from './api';
import { API_FOOD_TICKETS } from '../constants/api';

export const getMonthlyFoodTickets = (month, year) =>
  request(API_FOOD_TICKETS, {
    method: 'GET',
    params: { month, year }
  });
